export const PAGE_SEO = {
  home: {
    title: "Chahal Overseas Immigration | Immigration Consultant in Mississauga (RCIC-IRB)",
    description: "Regulated Canadian immigration consultant (RCIC-IRB) in Mississauga, Ontario. Help with visitor visas, study and work permits, Express Entry, PNP, family sponsorship and citizenship.",
  },
  services: {
    title: "Canadian Immigration Services | Chahal Overseas Immigration, Mississauga",
    description: "Visitor visas, Super Visa, study and work permits, PGWP, SOWP, LMIA, Express Entry, PNP, family sponsorship, citizenship and refusals. Immigration services from a Mississauga RCIC-IRB.",
  },
  about: {
    title: "About Amarvir Singh, RCIC-IRB | Chahal Overseas Immigration",
    description: "Meet Amarvir Singh, founder of Chahal Overseas Immigration and Regulated Canadian Immigration Consultant (RCIC-IRB) based in Mississauga, Ontario.",
  },
  contact: {
    title: "Contact Chahal Overseas Immigration | Mississauga Immigration Consultant",
    description: "Contact Chahal Overseas Immigration at Unit 231, 7025 Tomken Road, Mississauga. Call +1 647-575-1088, WhatsApp us, email, or book a paid consultation online.",
  },
  blog: {
    title: "IRCC News, Express Entry Draws & Immigration Guides | Chahal Overseas Immigration",
    description: "Canadian immigration news from a Mississauga RCIC-IRB: Express Entry draw results, IRCC policy updates and practical guides for visitors, students, workers and families.",
  },
  consultation: {
    title: "Free Immigration Consultation | Chahal Overseas Immigration, Mississauga",
    description: "Request a free introductory immigration consultation with Chahal Overseas Immigration. Choose your date, time and meeting style: phone, WhatsApp, video or in person in Mississauga.",
  },
  eligibility: {
    title: "Free Canada Immigration Eligibility Check | Chahal Overseas Immigration",
    description: "Take our free 1-minute Canada immigration eligibility quiz and see which pathways may fit you: Express Entry, PNP, study and work permits, family sponsorship and more.",
  },
  privacy: { h1: "Privacy Policy", path: "/privacy-policy", description: "Chahal Overseas Immigration respects your privacy and is committed to handling personal information responsibly." },
  terms: { h1: "Terms of Service", path: "/terms-of-service", description: "These terms apply to your use of the Chahal Overseas Immigration website and website-based enquiries." },
  disclaimer: { h1: "Immigration Disclaimer", path: "/disclaimer", description: "Please read this important information before relying on any content on this website." },
};
